<ng-container *ngIf="carregouPropriedades">

    <ng-container *ngIf="!esconderCabecalhoERodape">
        <header class="header">
            <ng-container *ngIf="!consultaInterna && !consultaExterna">
                <suite-rfb-header appName="NORMAS" appDescription="|&nbsp;&nbsp;ADMINISTRAÇÃO"></suite-rfb-header>
            </ng-container>
            <ng-container *ngIf="consultaInterna">
                <suite-rfb-header appName="NORMAS" appDescription="|&nbsp;&nbsp;AMBIENTE INTERNO"></suite-rfb-header>
            </ng-container>
            <ng-container *ngIf="consultaExterna">
                <suite-rfb-header appName="NORMAS" appDescription=""></suite-rfb-header>
            </ng-container>
        </header>
        <article>
            <div class="container" style="max-width: none">
                <suite-rfb-alert-messages></suite-rfb-alert-messages>
                <router-outlet></router-outlet>
            </div>
        </article>

        <ng-container *ngIf="consultaInterna || gerirAto">
            <app-normas-footer-interno></app-normas-footer-interno>
        </ng-container>
        <ng-container *ngIf="!(consultaInterna || gerirAto)">
            <suite-rfb-footer text="A visualização deste sistema é melhor nos navegadores Internet Explorer 8, Google Chrome 80, Mozilla Firefox 24 ou superiores"></suite-rfb-footer>
        </ng-container>

        <suite-rfb-loading></suite-rfb-loading>
    </ng-container>

    <ng-container *ngIf="esconderCabecalhoERodape">
        <router-outlet></router-outlet>
    </ng-container>

</ng-container>